import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

// Get Set / Partial Set Data

export const usePurchasesSets = ({ clientCode, limit = 10, searchTerm = "", isPartial = false }) => {
  return useInfiniteQuery({
    queryKey: ["sets", { clientCode, limit, searchTerm, isPartial }],
    queryFn: async ({ pageParam = 1 }) => {
      const endpoint = isPartial
        ? "/api/v9/myBinnys/getPartialSets"
        : "/api/v9/myBinnys/getSets";

      const response = await apiClient.post(endpoint, {
        clientCode,
        page: pageParam,
        limit,
        search: searchTerm,
      });

      const data = response.data.data;

      return {
        sets: data.sets,
        total: data.totalSets,
        page: pageParam,
        limit,
        totalPages: Math.ceil(data.totalSets / limit),
      };
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.totalPages) return lastPage.page + 1;
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled: !!clientCode,
  });
};


// Get Set Design...

const fetchSetsDesign = async ({ pageParam = 1, queryKey }) => {
  const [_key, { setId, sortBy, sortOrder, searchTerm, limit = 20, clientCode  }] = queryKey;

  const { data } = await apiClient.post("/api/v9/myBinnys/getSetsDesign", {
    setId,
    clientCode,
    sortBy,
    sortOrder,
    searchTerm,
    page: pageParam,
    limit,
  });

  return data;
};

export const useGetSetsDesign = ({
  setId,
  clientCode, 
  sortBy = "Design Date",
  sortOrder = "asc",
  searchTerm = "",
  limit = 20,
}) => {
  return useInfiniteQuery({
    queryKey: ["getSetsDesign", { setId, clientCode, sortBy, sortOrder, searchTerm, limit }],
    queryFn: fetchSetsDesign,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
    enabled: !!setId,
  });
};



// Get Partial Set Design

const getPartialSetsDesign = async ({ clientCode, setId }) => {
  const response = await apiClient.post("/api/v9/myBinnys/getPartialSetsDesign", {
    clientCode,
    setId,
  });
  return response.data?.data;
};

export const usePartialSetsDesign = ({ clientCode, setId, enabled = true }) => {
  return useQuery({
    queryKey: ["partialSetsDesign", clientCode, setId],
    queryFn: () => getPartialSetsDesign({ clientCode, setId }),
    enabled: !!clientCode && !!setId && enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};




export const getSingleSetDesigns = () => {
  return {
    message: "Set fetched successfully",
    set: {
      _id: "68f08f7700da923ac8efb31e",
      setNumber: "1238",
      styleRef: ["671729b40a4807b09e00e4f2", "671729b40a4807b09e00e4f6", "671729b40a4807b09e00e4f7", "671729b50a4807b09e00f609", "671729b40a4807b09e00e4fc"],
      userRef: "68ee0916cd0886e67d12a2ec",
      totalDiaPcs: 906,
      totalDiaWeight: 13.699,
      totalGoldGrossWeight: 159.94,
      totalGoldWeight: 156.67,
      totalSales: 54,
      numberOfStyles: 5,
      isArchive: false,
      createdAt: "2025-10-16T06:23:51.345Z",
      updatedAt: "2025-10-16T06:23:51.345Z",
      __v: 0,
      designs: [
        {
          _id: "671729b40a4807b09e00e4f2",
          styleNumber: "CH-00004",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "R",
          designClass: "Bronze",
          diaPcs: 26,
          diaWeight: 0.544,
          netWeight: 7.041,
          grossWeight: 7.18,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 11,
          bestSeller: true,
          cadIcon: false,
          itemSize: "40 CM",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 2,
          otherMaterialWeight: 0.03,
          images: [
            {
              _id: "6722108bd04da4dc89562aa1",
              styleNumber: "CH-00004",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.493Z",
              updatedAt: "2025-02-21T06:07:26.086Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "676cfdd8d503dfbe2cc1c6d9",
              collectionName: "Two Layers Neckwear",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 4,
          relavantSetsDesign: ["CH-00010", "CH-00011", "CH-00023", "CH-1003"],
        },
        {
          _id: "671729b40a4807b09e00e4f6",
          styleNumber: "CH-00010",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "X",
          designClass: "Bronze",
          diaPcs: 102,
          diaWeight: 1.428,
          netWeight: 40.5,
          grossWeight: 41.106,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 1,
          bestSeller: false,
          cadIcon: false,
          autoRestrict: false,
          autoRestrictDate: null,
          manualRestrictDate: "2025-06-11T00:00:00.000Z",
          itemSize: "",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 2,
          otherMaterialWeight: 0.32,
          images: [
            {
              _id: "6722108bd04da4dc89562aa5",
              styleNumber: "CH-00010",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00010.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.494Z",
              updatedAt: "2025-02-21T06:07:26.086Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00010.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "68307de90a4a6c10a1dc9025",
              collectionName: "collection testing",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 10,
          relavantSetsDesign: ["CH-00011", "CH-1003", "CH-0019", "CH-00004", "CH-00023"],
        },
        {
          _id: "671729b40a4807b09e00e4f7",
          styleNumber: "CH-00011",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "X",
          designClass: "Bronze",
          diaPcs: 72,
          diaWeight: 1.512,
          netWeight: 44.612,
          grossWeight: 45.094,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:07.798Z",
          restrict: false,
          totalSales: 4,
          bestSeller: true,
          cadIcon: false,
          autoRestrict: false,
          autoRestrictDate: null,
          manualRestrictDate: "2025-06-11T00:00:00.000Z",
          itemSize: "",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 1,
          otherMaterialWeight: 0.18,
          currentTrophy: "Bronze",
          totalTrophy: 1,
          images: [
            {
              _id: "6722108bd04da4dc89562aa6",
              styleNumber: "CH-00011",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00011.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.494Z",
              updatedAt: "2025-02-21T06:07:26.086Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00011.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "68307de90a4a6c10a1dc9025",
              collectionName: "collection testing",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 11,
          relavantSetsDesign: ["CH-00010", "CH-1003", "CH-0019", "CH-00004", "CH-00023"],
        },
        {
          _id: "671729b40a4807b09e00e4fc",
          styleNumber: "CH-1003",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "R",
          designClass: "Bronze",
          diaPcs: 418,
          diaWeight: 5.304,
          netWeight: 32.539,
          grossWeight: 33.6,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 16,
          bestSeller: true,
          cadIcon: false,
          itemSize: "50 CM",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 1,
          otherMaterialWeight: 0.05,
          images: [
            {
              _id: "6722108bd04da4dc89562b00",
              styleNumber: "CH-1003",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-1003.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.497Z",
              updatedAt: "2025-08-05T04:25:39.802Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-1003.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "68307de90a4a6c10a1dc9025",
              collectionName: "collection testing",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 1003,
          relavantSetsDesign: ["CH-00010", "CH-00011", "CH-0019", "CH-00004", "CH-00023"],
        },
        {
          _id: "671729b50a4807b09e00f609",
          styleNumber: "CH-00023",
          styleDate: "2019-04-18T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "R",
          designClass: "Bronze",
          diaPcs: 288,
          diaWeight: 4.911,
          netWeight: 31.978,
          grossWeight: 32.96,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.767Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 22,
          bestSeller: true,
          cadIcon: false,
          itemSize: "50 CM",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 0,
          otherMaterialWeight: 0,
          images: [
            {
              _id: "6722108bd04da4dc89562aac",
              styleNumber: "CH-00023",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-00023.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.494Z",
              updatedAt: "2025-07-14T07:27:13.168Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-00023.webp",
            },
          ],
          collectionDetails: [],
          stocks: 0,
          styleNumberNumeric: 23,
          relavantSetsDesign: ["CH-00004", "CH-00010", "CH-00011", "CH-1003"],
        },
      ],
    },
  };
};

export const getSetsData = () => {
  return {
    message: "Sets fetched successfully",
    sets: [
      {
        _id: "68d2328b023371cf35f6a2df",
        setNumber: "1235",
        styleRef: ["671729b50a4807b09e010451", "671729b50a4807b09e0105d4"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 68,
        totalDiaWeight: 2.85,
        totalGoldGrossWeight: 13.940000000000001,
        totalGoldWeight: 13.370000000000001,
        totalSales: 3,
        numberOfStyles: 2,
        isArchive: false,
        createdAt: "2025-09-23T05:39:23.649Z",
        updatedAt: "2025-09-23T05:39:23.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e0105d4",
              styleNumber: "BD-00032",
              styleDate: "2021-07-12T00:00:00.000Z",
              categoryName: "Bands",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 34,
              diaWeight: 2.14,
              netWeight: 8.64,
              grossWeight: 9.07,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.821Z",
              updatedAt: "2025-10-14T16:40:03.734Z",
              restrict: true,
              bestSeller: false,
              totalSales: 2,
              cadIcon: false,
              itemSize: "20",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              images: [
                {
                  _id: "67220d7ec535235d65c66fe8",
                  styleNumber: "BD-00032",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:42:06.347Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.webp",
                },
              ],
              relavantSetsDesign: ["BD-00031"],
            },
            {
              _id: "671729b50a4807b09e010451",
              styleNumber: "BD-00031",
              styleDate: "2021-05-12T00:00:00.000Z",
              categoryName: "Bands",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 34,
              diaWeight: 0.71,
              netWeight: 4.73,
              grossWeight: 4.87,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.810Z",
              updatedAt: "2025-10-14T16:40:03.734Z",
              restrict: true,
              bestSeller: false,
              totalSales: 1,
              cadIcon: false,
              itemSize: "14",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              images: [
                {
                  _id: "67220d7ec535235d65c66fe7",
                  styleNumber: "BD-00031",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:42:06.347Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.webp",
                },
              ],
              relavantSetsDesign: ["BD-00032"],
            },
          ],
        ],
        collectionDetails: [],
        designImages: [
          {
            _id: "67220d7ec535235d65c66fe7",
            styleNumber: "BD-00031",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:42:06.347Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.webp",
          },
          {
            _id: "67220d7ec535235d65c66fe8",
            styleNumber: "BD-00032",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:42:06.347Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
    ],
    total: 5,
    pagination: {
      pageNumber: 1,
      limit: 12,
      totalPages: 99,
      totalSets: 1186,
    },
  };
};

export const getPartialSetsData = () => {
  return {
    message: "Sets fetched successfully",
    sets: [
      {
        _id: "68d2328b023371cf35f6a2df",
        setNumber: "1235",
        styleRef: ["671729b50a4807b09e010451", "671729b50a4807b09e0105d4"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 68,
        totalDiaWeight: 2.85,
        totalGoldGrossWeight: 13.940000000000001,
        totalGoldWeight: 13.370000000000001,
        totalSales: 3,
        numberOfStyles: 2,
        isArchive: false,
        createdAt: "2025-09-23T05:39:23.649Z",
        updatedAt: "2025-09-23T05:39:23.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e0105d4",
              styleNumber: "BD-00032",
              styleDate: "2021-07-12T00:00:00.000Z",
              categoryName: "Bands",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 34,
              diaWeight: 2.14,
              netWeight: 8.64,
              grossWeight: 9.07,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.821Z",
              updatedAt: "2025-10-14T16:40:03.734Z",
              restrict: true,
              bestSeller: false,
              totalSales: 2,
              cadIcon: false,
              itemSize: "20",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
              images: [
                {
                  _id: "67220d7ec535235d65c66fe8",
                  styleNumber: "BD-00032",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:42:06.347Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.webp",
                },
              ],
              relavantSetsDesign: ["BD-00031"],
              isPurchased: true,
            },
            {
              _id: "671729b50a4807b09e010451",
              styleNumber: "BD-00031",
              styleDate: "2021-05-12T00:00:00.000Z",
              categoryName: "Bands",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 34,
              diaWeight: 0.71,
              netWeight: 4.73,
              grossWeight: 4.87,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.810Z",
              updatedAt: "2025-10-14T16:40:03.734Z",
              restrict: true,
              bestSeller: false,
              totalSales: 1,
              cadIcon: false,
              itemSize: "14",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
              images: [
                {
                  _id: "67220d7ec535235d65c66fe7",
                  styleNumber: "BD-00031",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:42:06.347Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.webp",
                },
              ],
              relavantSetsDesign: ["BD-00032"],
              isPurchased: true,
            },
          ],
        ],
        collectionDetails: [],
        designImages: [
          {
            _id: "67220d7ec535235d65c66fe7",
            styleNumber: "BD-00031",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:42:06.347Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00031.webp",
          },
          {
            _id: "67220d7ec535235d65c66fe8",
            styleNumber: "BD-00032",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:42:06.347Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bands/BD-00032.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
              isPurchased: true,
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
      {
        _id: "68cd3025d618fcd53e61acc9",
        setNumber: "1234",
        styleRef: ["671729b40a4807b09e00e39c", "671729b50a4807b09e010b47", "671729b50a4807b09e011a87", "671729b40a4807b09e00e421", "671729b50a4807b09e011445", "671729b50a4807b09e011561"],
        userRef: "67cea2b64c969d8c5d0ef841",
        totalDiaPcs: 245,
        totalDiaWeight: 5.7299999999999995,
        totalGoldGrossWeight: 71.17,
        totalGoldWeight: 68.12,
        totalSales: 11,
        numberOfStyles: 6,
        isArchive: false,
        createdAt: "2025-09-19T10:27:49.649Z",
        updatedAt: "2025-09-19T10:27:49.649Z",
        __v: 0,
        designs: [
          [
            {
              _id: "671729b50a4807b09e011a87",
              styleNumber: "BA-00357",
              styleDate: "2024-01-01T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "O Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 14,
              diaWeight: 0.35,
              netWeight: 4.62,
              grossWeight: 4.692,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.887Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              manualRestrictDate: "2025-08-14T00:00:00.000Z",
              autoRestrict: false,
              autoRestrictDate: null,
              itemSize: "",
              colorStonePcs: 2,
              colorStoneWeight: 0.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380da7",
                  styleNumber: "BA-00357",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.335Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011445",
              styleNumber: "CH-00128",
              styleDate: "2023-04-26T00:00:00.000Z",
              categoryName: "Ladies Chains",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 48,
              diaWeight: 2.4,
              netWeight: 37.48,
              grossWeight: 37.97,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.864Z",
              updatedAt: "2025-10-14T16:40:04.578Z",
              restrict: true,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              autoRestrict: false,
              autoRestrictDate: null,
              manualRestrictDate: "2025-08-25T00:00:00.000Z",
              images: [
                {
                  _id: "6722137f4360076d89ce04dc",
                  styleNumber: "CH-00128",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:07:43.697Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e011561",
              styleNumber: "CM-00028",
              styleDate: "2023-06-19T00:00:00.000Z",
              categoryName: "Charms",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 19,
              diaWeight: 0.172,
              netWeight: 1.566,
              grossWeight: 1.61,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.867Z",
              updatedAt: "2025-10-14T16:40:01.824Z",
              restrict: false,
              totalSales: 3,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.01,
              images: [
                {
                  _id: "67220f12aa8610b98c1069b8",
                  styleNumber: "CM-00028",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T10:48:50.483Z",
                  updatedAt: "2025-06-03T08:48:31.372Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "BE-00003", "CH-00128"],
            },
            {
              _id: "671729b40a4807b09e00e421",
              styleNumber: "BE-00003",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "X",
              designClass: "Bronze",
              diaPcs: 62,
              diaWeight: 1.12,
              netWeight: 10.89,
              grossWeight: 11.11,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.642Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              images: [
                {
                  _id: "672214ac813de1d0091491e4",
                  styleNumber: "BE-00003",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.084Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00259", "BA-00357", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b50a4807b09e010b47",
              styleNumber: "BA-00259",
              styleDate: "2022-03-04T00:00:00.000Z",
              categoryName: "Bali",
              subCategoryName: "U Bali",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 102,
              diaWeight: 1.693,
              netWeight: 10.417,
              grossWeight: 11.758,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.835Z",
              updatedAt: "2025-10-14T16:40:03.869Z",
              restrict: false,
              totalSales: 4,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 14,
              colorStoneWeight: 5.01,
              otherMaterialPcs: 0,
              otherMaterialWeight: 0,
              images: [
                {
                  _id: "67221f826f3b03fb44380d46",
                  styleNumber: "BA-00259",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:58:58.331Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
                },
              ],
              relavantSetsDesign: ["AN-1001", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
            {
              _id: "671729b40a4807b09e00e39c",
              styleNumber: "AN-1001",
              styleDate: "2019-04-01T00:00:00.000Z",
              categoryName: "Other",
              subCategoryName: "Standard",
              makeType: "R",
              designClass: "Bronze",
              diaPcs: 0,
              diaWeight: 0,
              netWeight: 3.14,
              grossWeight: 4.03,
              __v: 0,
              createdAt: "2024-10-22T04:27:33.637Z",
              updatedAt: "2025-10-14T16:40:02.867Z",
              restrict: false,
              totalSales: 1,
              bestSeller: false,
              cadIcon: false,
              itemSize: "",
              colorStonePcs: 0,
              colorStoneWeight: 0,
              otherMaterialPcs: 1,
              otherMaterialWeight: 0.89,
              images: [
                {
                  _id: "672214ac813de1d0091491e1",
                  styleNumber: "AN-1001",
                  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
                  __v: 0,
                  createdAt: "2024-10-30T11:12:44.083Z",
                  updatedAt: "2025-02-21T06:07:26.086Z",
                  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
                },
              ],
              relavantSetsDesign: ["BA-00259", "BA-00357", "BE-00003", "CH-00128", "CM-00028"],
            },
          ],
        ],
        collectionDetails: [
          {
            _id: "6757e79fe7acc6d36c4c0a37",
            collectionName: "Enamel",
          },
          {
            _id: "675d598d2bd0919cb6ed42df",
            collectionName: "Colour Stone",
          },
          {
            _id: "67760f256d49a537ffcb3350",
            collectionName: "Heart",
          },
          {
            _id: "67765a673382ba2afe629b0f",
            collectionName: "Fancy Diamond",
          },
        ],
        designImages: [
          {
            _id: "672214ac813de1d0091491e1",
            styleNumber: "AN-1001",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.083Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/AN-1001.webp",
          },
          {
            _id: "67221f826f3b03fb44380d46",
            styleNumber: "BA-00259",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.331Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00259.webp",
          },
          {
            _id: "67221f826f3b03fb44380da7",
            styleNumber: "BA-00357",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:58:58.335Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Bali/BA-00357.webp",
          },
          {
            _id: "672214ac813de1d0091491e4",
            styleNumber: "BE-00003",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:12:44.084Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Other/BE-00003.webp",
          },
          {
            _id: "6722137f4360076d89ce04dc",
            styleNumber: "CH-00128",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Ladies Chains/CH-00128.jpg",
            __v: 0,
            createdAt: "2024-10-30T11:07:43.697Z",
            updatedAt: "2025-02-21T06:07:26.086Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Ladies%20Chains/CH-00128.webp",
          },
          {
            _id: "67220f12aa8610b98c1069b8",
            styleNumber: "CM-00028",
            imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.jpg",
            __v: 0,
            createdAt: "2024-10-30T10:48:50.483Z",
            updatedAt: "2025-06-03T08:48:31.372Z",
            transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CM-00028.webp",
          },
        ],
      },
    ],
    total: 5,
    pagination: {
      pageNumber: 1,
      limit: 12,
      totalPages: 99,
      totalSets: 1186,
    },
  };
};

export const getSinglePartialSetDesigns = () => {
  return {
    message: "Set fetched successfully",
    set: {
      _id: "68f08f7700da923ac8efb31e",
      setNumber: "1238",
      styleRef: ["671729b40a4807b09e00e4f2", "671729b40a4807b09e00e4f6", "671729b40a4807b09e00e4f7", "671729b50a4807b09e00f609", "671729b40a4807b09e00e4fc"],
      userRef: "68ee0916cd0886e67d12a2ec",
      totalDiaPcs: 906,
      totalDiaWeight: 13.699,
      totalGoldGrossWeight: 159.94,
      totalGoldWeight: 156.67,
      totalSales: 54,
      numberOfStyles: 5,
      isArchive: false,
      createdAt: "2025-10-16T06:23:51.345Z",
      updatedAt: "2025-10-16T06:23:51.345Z",
      __v: 0,
      designs: [
        {
          _id: "671729b40a4807b09e00e4f2",
          styleNumber: "CH-00004",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "R",
          designClass: "Bronze",
          diaPcs: 26,
          diaWeight: 0.544,
          netWeight: 7.041,
          grossWeight: 7.18,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 11,
          bestSeller: true,
          cadIcon: false,
          itemSize: "40 CM",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 2,
          otherMaterialWeight: 0.03,
          imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
          transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
          images: [
            {
              _id: "6722108bd04da4dc89562aa1",
              styleNumber: "CH-00004",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.493Z",
              updatedAt: "2025-02-21T06:07:26.086Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "676cfdd8d503dfbe2cc1c6d9",
              collectionName: "Two Layers Neckwear",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 4,
          relavantSetsDesign: ["CH-00010", "CH-00011", "CH-00023", "CH-1003"],
          isPurchased: true,
        },
        {
          _id: "671729b40a4807b09e00e4f6",
          styleNumber: "CH-00010",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "X",
          designClass: "Bronze",
          diaPcs: 102,
          diaWeight: 1.428,
          netWeight: 40.5,
          grossWeight: 41.106,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 1,
          bestSeller: false,
          cadIcon: false,
          autoRestrict: false,
          autoRestrictDate: null,
          manualRestrictDate: "2025-06-11T00:00:00.000Z",
          itemSize: "",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 2,
          otherMaterialWeight: 0.32,
          imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
          transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
          images: [
            {
              _id: "6722108bd04da4dc89562aa5",
              styleNumber: "CH-00010",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00010.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.494Z",
              updatedAt: "2025-02-21T06:07:26.086Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00010.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "68307de90a4a6c10a1dc9025",
              collectionName: "collection testing",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 10,
          relavantSetsDesign: ["CH-00011", "CH-1003", "CH-0019", "CH-00004", "CH-00023"],
          isPurchased: true,
        },

        {
          _id: "671729b40a4807b09e00e4f7",
          styleNumber: "CH-00011",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "X",
          designClass: "Bronze",
          diaPcs: 72,
          diaWeight: 1.512,
          netWeight: 44.612,
          grossWeight: 45.094,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:07.798Z",
          restrict: false,
          totalSales: 4,
          bestSeller: true,
          cadIcon: false,
          autoRestrict: false,
          autoRestrictDate: null,
          manualRestrictDate: "2025-06-11T00:00:00.000Z",
          itemSize: "",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 1,
          otherMaterialWeight: 0.18,
          currentTrophy: "Bronze",
          totalTrophy: 1,
          imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
          transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
          images: [
            {
              _id: "6722108bd04da4dc89562aa6",
              styleNumber: "CH-00011",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00011.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.494Z",
              updatedAt: "2025-02-21T06:07:26.086Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00011.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "68307de90a4a6c10a1dc9025",
              collectionName: "collection testing",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 11,
          relavantSetsDesign: ["CH-00010", "CH-1003", "CH-0019", "CH-00004", "CH-00023"],
        },

        {
          _id: "671729b40a4807b09e00e4fc",
          styleNumber: "CH-1003",
          styleDate: "2019-04-01T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "R",
          designClass: "Bronze",
          diaPcs: 418,
          diaWeight: 5.304,
          netWeight: 32.539,
          grossWeight: 33.6,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.650Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 16,
          bestSeller: true,
          cadIcon: false,
          itemSize: "50 CM",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 1,
          otherMaterialWeight: 0.05,
          imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Gents Chains/CH-00004.jpg",
          transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Gents%20Chains/CH-00004.webp",
          images: [
            {
              _id: "6722108bd04da4dc89562b00",
              styleNumber: "CH-1003",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-1003.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.497Z",
              updatedAt: "2025-08-05T04:25:39.802Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-1003.webp",
            },
          ],
          collectionDetails: [
            {
              _id: "68307de90a4a6c10a1dc9025",
              collectionName: "collection testing",
            },
          ],
          stocks: 0,
          styleNumberNumeric: 1003,
          relavantSetsDesign: ["CH-00010", "CH-00011", "CH-0019", "CH-00004", "CH-00023"],
        },
        {
          _id: "671729b50a4807b09e00f609",
          styleNumber: "CH-00023",
          styleDate: "2019-04-18T00:00:00.000Z",
          categoryName: "Gents Chains",
          subCategoryName: "Standard",
          makeType: "R",
          designClass: "Bronze",
          diaPcs: 288,
          diaWeight: 4.911,
          netWeight: 31.978,
          grossWeight: 32.96,
          __v: 0,
          createdAt: "2024-10-22T04:27:33.767Z",
          updatedAt: "2025-10-15T16:40:04.150Z",
          restrict: false,
          totalSales: 22,
          bestSeller: true,
          cadIcon: false,
          itemSize: "50 CM",
          colorStonePcs: 0,
          colorStoneWeight: 0,
          otherMaterialPcs: 0,
          otherMaterialWeight: 0,
          imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-00023.jpg",
          transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-00023.webp",
          images: [
            {
              _id: "6722108bd04da4dc89562aac",
              styleNumber: "CH-00023",
              imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-00023.jpg",
              __v: 0,
              createdAt: "2024-10-30T10:55:07.494Z",
              updatedAt: "2025-07-14T07:27:13.168Z",
              transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/Upload_Update_Images/CH-00023.webp",
            },
          ],
          collectionDetails: [],
          stocks: 0,
          styleNumberNumeric: 23,
          relavantSetsDesign: ["CH-00004", "CH-00010", "CH-00011", "CH-1003"],
          isPurchased: true,
        },
      ],
    },
  };
};
